import request from '@/api/axioRequest.js'

export default {
  getSchedule () {
    return request.get('schedule/get/')
  },
  saveSchedule (data) {
    return request.post('schedule/save/', data)
  },
  runSchedule () {
    return request.get('integration/run/')
  }
}
